import { LIGHT_GENE_BG_MID, PREVALENCE_LETTER_THRESHOLD } from './styles';


const HASH_WEIGHT = 4;
const HASH_SPACING = 6;


export class MutationBlockHorizontal {
//

  constructor(mutation, pct, count, isWildType) {
    this.mutation = mutation;
    this.pct = pct;
    this.count = count;
    this.x = 0;
    this.y = 0;
    this.w = 0;
    this.h = 0;
    this.color = LIGHT_GENE_BG_MID;//LIGHT_GENE_BG;
    this.label = isWildType ? (mutation.refAA === 'DEL' ? '' : mutation.refAA)
      : mutation.isDeletion ? '∆' : mutation.altAA || mutation.refAA;
    // if (mutation.gene === "S" && mutation.position === 452) {
    //   console.log(mutation.name, this.label)
    // }
  }


  draw(ctx) {
    /* set by the mutation block for now */
    if (this.border) {
      ctx.lineWidth = this.border;
      ctx.strokeStyle = 'white';
      ctx.beginPath();
      ctx.moveTo(this.x - this.border * 0.5, this.y);
      ctx.lineTo(this.x - this.border * 0.5, this.y + this.h);
      ctx.moveTo(this.x + this.w + this.border * 0.5, this.y);
      ctx.lineTo(this.x + this.w + this.border * 0.5, this.y + this.h);
      ctx.stroke();
    }
    // if (this.mutation.name.substring(0, 10) === 'ORF1a:T842') {
    //   console.log('     draw block', this.x, this.w);
    // }
    if (ctx.fillStyle !== this.color) {
      ctx.fillStyle = this.color;
    }
    ctx.fillRect(this.x, this.y, this.w, this.h);
    if (this.count === 0) {
      this.drawHash(ctx);
    }
  }


  /*
  warning: the white stripes here overshoot the bottom of the block.
  For now it's doubly safe because 1) there's space between the rows
  and 2) the lower rows are drawn later. But if both those should
  change, that could end up a problem.
  */
  drawHash(ctx) {
    ctx.fillStyle = 'white';
    let {x, y, w, h} = this,
      x1 = x,
      x2 = x + w,
      y2 = y + h,
      drawStripe = (x, y)=>{
        let w = x2 - x,
          y_2 = y + w,
          x_2 = x + w;
        ctx.moveTo(x, y);
        ctx.lineTo(x_2, y_2);
        ctx.lineTo(x_2, y_2 + HASH_WEIGHT);
        if (x > x1) {
          x -= HASH_WEIGHT;
          y -= HASH_WEIGHT;
        }
        ctx.lineTo(x, y + HASH_WEIGHT);
      };
    ctx.beginPath();
    ctx.strokeStyle = 'red';
    while (x < x2) {
      drawStripe(x, y);
      x += HASH_SPACING;
    }
    x = x1
    y += HASH_SPACING;
    while (y < y2) {
      drawStripe(x, y);
      y += HASH_SPACING;
    }
    ctx.fill();
  }


  drawLetter(ctx) {
    if (this.pct > PREVALENCE_LETTER_THRESHOLD) {
      let {label, x, y, w, h} = this;
      ctx.fillText(label, x + w * 0.5, y + h * 0.7);
    }
  }


}
